import { createTheme, alpha } from "@mui/material/styles";

export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1d4ed8",
      light: "#3b82f6",
      dark: "#1e40af",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#0d9488",
      light: "#14b8a6",
      dark: "#0f766e",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f4f6fb",
      paper: "#ffffff",
    },
    text: {
      primary: "#0f172a",
      secondary: "#475569",
    },
    divider: alpha("#0f172a", 0.08),
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily:
      '"DM Sans", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 800, letterSpacing: "-0.02em" },
    h2: { fontWeight: 800, letterSpacing: "-0.02em" },
    h3: { fontWeight: 800, letterSpacing: "-0.02em" },
    h4: { fontWeight: 800, letterSpacing: "-0.01em" },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { fontWeight: 700, letterSpacing: "0.02em" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          textRendering: "optimizeLegibility",
          WebkitFontSmoothing: "antialiased",
        },
        "#root": { isolation: "isolate" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: false },
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 12,
          paddingInline: 22,
          paddingBlock: 10,
          transition:
            "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease",
          "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
          },
        },
        containedPrimary: {
          boxShadow: `0 8px 24px ${alpha("#1d4ed8", 0.35)}`,
          "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: `0 12px 28px ${alpha("#1d4ed8", 0.4)}`,
          },
          "@media (prefers-reduced-motion: reduce)": {
            "&:hover": { transform: "none" },
          },
        },
        outlined: {
          borderWidth: 2,
          "&:hover": { borderWidth: 2 },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
        rounded: {
          borderRadius: 18,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          textUnderlineOffset: 3,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiRating: {
      styleOverrides: {
        iconFilled: { color: "#f59e0b" },
        iconHover: { color: "#fbbf24" },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.Mui-focusVisible": {
            outline: "3px solid",
            outlineColor: alpha("#1d4ed8", 0.45),
            outlineOffset: 2,
          },
        },
      },
    },
  },
});

export function mainAreaBackground(theme: typeof appTheme): string {
  const a = alpha(theme.palette.primary.main, 0.14);
  const b = alpha(theme.palette.secondary.main, 0.12);
  const c = alpha(theme.palette.primary.light, 0.2);
  return `linear-gradient(145deg, ${theme.palette.background.default} 0%, ${a} 42%, ${c} 72%, ${b} 100%)`;
}
